import { network } from './network';

export async function getAppInfo(opts) {
	const res = await network({
		url: `/api/v1/app/global`,
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}